document.addEventListener("DOMContentLoaded", function () {
  var myButton = document.getElementById("myBtnscroll");

  if (!myButton) {
    console.error("Scroll-to-top button not found!");
    return;
  }

  // Show button when scrolling down 300px
  window.addEventListener("scroll", function () {
    if (window.scrollY > 900) {
      myButton.style.display = "block";
    } else {
      myButton.style.display = "none";
    }
  });

  // Scroll to top when clicked
  myButton.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});
